import { FC, PropsWithChildren } from 'react'
import { WebPushNotificationsClient } from './webPushNotificationsClient'
import { WebPushNotificationsContext } from './WebPushNotificationsContext'

type Props = PropsWithChildren<{
    client: WebPushNotificationsClient
}>

export const WebPushNotificationsProvider: FC<Props> = ({ children, client }) => {
    return (
        <WebPushNotificationsContext.Provider value={{ client }}>
            {children}
        </WebPushNotificationsContext.Provider>
    )
}
